import React, { useContext, useState } from 'react';
import EmailInput from './EmailInput/EmailInput';
import EmailConfirmation from './EmailConfirmation/EmailConfirmation';
import { LocalizationContext } from '../../../context/localizationContext';
import Styles from './ArccosEmail.module.scss';

const ArccosEmail = (props) => {
  const localization = useContext(LocalizationContext);
  const { setLoading } = props;
  const { tileText } = localization;
  const [emailSubmitted, setEmailSubmit] = useState(false);
  const [userEmail, setUserEmail] = useState(null);

  return (
    <div className={Styles.arccosEmail}>
      {emailSubmitted
        ? (
          <EmailConfirmation
            setLoading={setLoading}
            userEmail={userEmail}
          />
        )
        : (
          <EmailInput
            setEmailSubmit={setEmailSubmit}
            setUserEmail={setUserEmail}
            userEmail={userEmail}
          />
        )}
    </div>
  );
};

export default ArccosEmail;
